import { EServiceCategory, ETaskType, EKitCheckItemType, ESessionImageVerificationStatus } from "../constants";
import { ISession } from "./session";
import { AdminTaskResponseDto } from "./task";

export enum EKitCheckStatus {
  PENDING_REVIEW = "PENDING_REVIEW",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export interface IKitCheckItem {
  type: EKitCheckItemType;
  imageUrl: string;
  currentStatus: ESessionImageVerificationStatus;
}

export interface IKitCheckSessionData {
  session: ISession;
  scheduledAt: number;
  city: string;
  items: IKitCheckItem[];
}

export interface IKitCheckTaskItem {
  id: string; // Format: "session_{sessionId}"
  taskType: ETaskType.KIT_CHECK;
  status: EKitCheckStatus;
  data: IKitCheckSessionData;
}

export interface IKitCheckDisplayItem {
  id: string;
  status: EKitCheckStatus;
  sessionId: string;
  userName: string;
  petName: string;
  serviceCategory: EServiceCategory;
  partnerId: string;
  partnerName: string;
  partnerCity: string;
  city: string;
  scheduledAt: number;
  selfie?: IKitCheckItem;
  tshirt?: IKitCheckItem;
  shoes?: IKitCheckItem;
}

export type IKitCheckTaskResponseDto = AdminTaskResponseDto<IKitCheckSessionData>;